import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoGl: CultureInfo = {
  name: 'gl',
  displayName: 'Galician',
  iso3LanguageCode: 'glg',
  iso2LanguageCode: 'gl',
  ietfLanguageTag: 'gl',
  parent: null
};
